import { getTransactions, editTransaction, deleteTransaction } from '@/api'
//
export default {
	namespaced: true,

	state: {
		transactions: []
	},

	mutations: {
		setTransactions (state, transactions) {
			state.transactions = transactions
		}
	},

	actions: {
		getTransactions (store, params) {
			return getTransactions(params)
				.then(response => {
					store.commit('setTransactions', response.data.result)
				})
		},

		editTransaction (store, transaction, enableReferal) {
			return editTransaction(transaction._id, transaction, enableReferal)
				.then(response => {
					store.dispatch('getTransactions')
				})
		},

		deleteTransaction (store, id) {
			return deleteTransaction(id)
				.then(response => {
					console.log(response)
					store.dispatch('getTransactions')
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/transactions.js